import { MutationTree } from "vuex";
import { ServiceImplementationState, ServiceImplementation } from "./model";

const mutations: MutationTree<ServiceImplementationState> = {
  setServiceImplementations(state, serviceImplementations: ServiceImplementation[]) {
    state.serviceImplementations = serviceImplementations
  },
  setServiceImplementation(state, serviceImplementation: ServiceImplementation) {
    state.serviceImplementation = serviceImplementation
  },
  addServiceImplementation(state, serviceImplementation: ServiceImplementation) {
    state.serviceImplementations.push(serviceImplementation)
  },
  updateServiceImplementation(state, serviceImplementation: ServiceImplementation) {
    const index = state.serviceImplementations.findIndex(c => c.id === serviceImplementation.id);
    if(index !== -1) {
      state.serviceImplementations.splice(index, 1, serviceImplementation);
    }
  },
  replaceServiceImplementation(state, serviceImplementation: ServiceImplementation) {
    const index = state.serviceImplementations.findIndex(c => c.id === serviceImplementation.id);
    if (index !== -1) {
      state.serviceImplementations.splice(index, 1, serviceImplementation);
    } else {
      state.serviceImplementations.push(serviceImplementation)
    }
  },
  deleteServiceImplementation(state, id: string) {
    state.serviceImplementations = state.serviceImplementations.filter(serviceImplementation => serviceImplementation.id !== id)
  }
}

export default mutations;
